import React from "react";
import { Tag } from "../ui/Tag";
import { Card } from "../ui/Card";
import highlightWiseMate from "../hooks/highlightWord";
import { renderHTML } from "../hooks/htmlToText";
import { BookButton } from "../ui/BookButton";
import { useTranslation } from "react-i18next";

export const Features = () => {
  const { t } = useTranslation();
  const features = t("features.items", { returnObjects: true }) as {
    title: string;
    subtitle: string;
  }[];

  return (
    <div
      className="flex flex-col lg:gap-[80px] justify-center lg:max-w-[1200px] mx-auto w-[96%] items-center lg:mb-[144px]"
      id="features"
    >
      <div className="md:top-[56px] md:mb-[56px] items-center text-center gap-6 flex-col flex md:w-full lg:w-[60%] relative">
        <Tag tag={t("tags.features")} />
        <p className="text-primary-700 text-[32px] lg:text-[40px] font-600  md:tracking-[-1.2px] w-full">
          {highlightWiseMate(t("homeFeatureSection.title"), "font-700")}
        </p>
        <div className="w-fit text-neutral-200 text-[16px] md:text-[18px] font-400">
          {renderHTML(t("homeFeatureSection.subtitle"))}
          <br className="hidden lg:block" />
          {renderHTML(t("homeFeatureSection.subtitleStrong"))}
        </div>
        <div className="w-fit">
          <BookButton />
        </div>
      </div>

      <div className="mt-[64px] lg:mt-0 w-[90%] md:w-[85%] flex flex-col gap-[64px] lg:gap-[100px]">
        {features.map((eachCard, index) => (
          <Card
            key={index}
            title={eachCard.title}
            subtitle={eachCard.subtitle}
            index={index}
            isLastCard={index === features.length - 1}
          />
        ))}
      </div>
    </div>
  );
};
